import { useRef, useState } from 'react';
import { Editor } from '@tinymce/tinymce-react';

import { baseUrl } from '../../Constants';

const MarkupEditor = function ({
  id,
  markup = '',
  onChange = (content) => { },
  maxLength,
}) {

  const initialValue = useState(markup)[0];
  const editorRef = useRef(null);

  const handleChange = (content, editor) => {
    const charcount = editor.plugins.wordcount.body.getCharacterCount();

    if (maxLength && charcount >= maxLength) return true;

    onChange(content);
  };

  const onKeyDown = (event, editor) => {
    if (event.keyCode === 32) {
      const charcount = editor.getContent({ format: 'text' }).length;

      if (maxLength && charcount >= maxLength) event.preventDefault();
    }
  };
  return (
    <>
      <Editor
        id={id}
        onInit={(evt, editor) => { editorRef.current = editor; }}
        initialValue={initialValue}
        value={markup}
        tinymceScriptSrc={`${baseUrl}/tinymce/tinymce.min.js`}
        init={{
          paste_data_images: true,
          height: 250,
          menubar: false,
          language: 'fi',
          valid_elements: 'a[href|data*]',
          extended_valid_elements: 'a[href|target=mobile]',
          force_br_newlines: false,
          force_p_newlines: false,
          forced_root_block: '',
          entity_encoding: "raw",
          target_list: [
            { text: 'Current window', value: '' },
            { text: 'New window', value: '_blank' },
            { text: 'Mobiilisovellus', value: 'mobile' }
          ],

          plugins: [
            'link',
            'wordcount'
          ],

          init_instance_callback: (editor) => {
            editor.getContainer().querySelector('button.tox-statusbar__wordcount').click();
          },

          toolbar: 'link',
        }}
        onEditorChange={handleChange}
        onKeyDown={onKeyDown}

      />
    </>
  );
};

export default MarkupEditor;
